// extracted by mini-css-extract-plugin
module.exports = {"content":"_9d67c4f8","item":"_662e75a4","image":"_7d07b56","itemTitle":"_3c8fef64","deleteNote":"_e1689158","deleteText":"_2949a535","textArea":"_a1b83d7b","submit":"_4a19fc05"};